<template>

    <!-- QT連携 -->
    <fieldset id="qt">
        <legend>QualityTracker連携(任意)</legend>
        <div>
            QualityTrackerにテストデータを送信するための情報を入力してください。
            <QtHelp /><br>
            QualityTrackerを使用することで、テスト実施管理や結果の集計が容易になります。<br>
            詳しくは
            <a href="https://service.valtes.co.jp/t-dash/function/tutorial/topic/qualitytracker_linkage"
                target="_blank">T-DASHチュートリアル</a>
            または
            <a href="https://service.valtes.co.jp/qualitytracker/" target="_blank">QualityTracker公式サイト</a>
            をご覧ください。
        </div>
        <div class="form-warn">
            ■注意事項<br>
            1. QualityTrackerと連携できるT-DASHのテストランは、1実行につき1つです。
        </div>
        <div class="form-area">
            <!-- 必須 -->
            <label for="qtWorkspaceTestrun">・ワークスペース</label><br>
            <input type="text" class="input-text" id="qtWorkspaceTestrun" v-model="inputedQt.workspace"
                name="qtWorkspaceTestrun" @input="updateOpt" placeholder="your_workspace"><br>
            <label for="qtApiKeyTestrun">・APIキー</label><br>
            <input type="text" class="input-text" id="qtApiKeyTestrun" v-model="inputedQt.apiKey"
                name=" qtApiKeyTestrun" @input="updateOpt" placeholder="your_api"><br>
            <label for="qtTdashTestrunTestrun">・QualityTrackerに連携するT-DASHのテストラン名</label><br>
            <div v-if="isExistTestrunCandidate">
                <select id="qtTdashTestrunTestrun" class="input-text" v-model="inputedQt.tdashTestrun"
                    @change="updateOpt">
                    <option value="">選択してください</option>
                    <option v-for="option in testrunNameList" :key="option" :value="option">{{ option }}
                    </option>
                </select><br>
            </div>
            <div v-else>
                <input type="text" class="input-text msg-input" placeholder="「実行するテストラン名」フォームを入力すると選択できます。" disabled>
            </div>
            <label for="qtQtProjectTestrun">・QualityTrackerの連携先プロジェクト名</label><br>
            <input type="text" class="input-text" id="qtQtProjectTestrun" v-model="inputedQt.qtProject"
                name="qtQtProjectTestrun" @input="updateOpt" placeholder="your_qt_project"><br>
            <!-- 任意 -->
            <div v-if="includesUseExistingTestOpt">
                <input type="checkbox" id="qtUsePreviousTestrunTestrunCheckBox" v-model="inputedQt.usePreviousTestrun"
                    class="input-checkbox qt-checkbox" name="qtUsePreviousTestrunTestrunCheckBox" value="true"
                    @change="updateOpt">
                <label for="qtUsePreviousTestrunTestrunCheckBox">QualityTrackerの連携先テストランを以前実行したテストランにする</label><br>
            </div>
            <div v-else>
                <label for="qtUsePreviousTestrunTestrunCheckBox">・QualityTrackerの連携先テストランを以前実行したテストランにする</label><br>
                <input type="text" class="input-text msg-input"
                    placeholder="ここを設定したい場合は、「プロジェクトインポート」フォームで、「プロジェクトインポートしない」を選択してください。" disabled>
            </div>
            <label for="qtStartDateTestrun">・予定開始日</label><br>
            <input type="date" class="input-date" id="qtStartDateTestrun" v-model="inputedQt.startDate"
                name="qtStartDateTestrun" min="2020-01-01" :max="inputedQt.endDate || '9999-12-31'"
                @input="updateOpt"><br>
            <label for="qtEndDateTestrun">・予定終了日</label><br>
            <input type="date" class="input-date" id="qtEndDateTestrun" v-model="inputedQt.endDate"
                name="qtEndDateTestrun" :min="inputedQt.startDate || '2020-01-01'" max="9999-12-31"
                @input="updateOpt"><br>
        </div>
    </fieldset>

    <!-- QT用プロキシ -->
    <fieldset v-if="isNeedQt && isSilent" id="qtProxy">
        <legend>QualityTracker連携用プロキシ(任意)</legend>
        <div>
            QualityTracker連携時に使用するプロキシを入力してください。
        </div>
        <div class="form-warn">
            ■注意事項<br>
            1. この設定が必要かどうかはネットワーク管理者に確認してください。<br>
            2. XX_winコマンド、または非対話型で実行する時に、プロキシを使用する場合は必ず入力してください。<br>
            3. アドレスとポートが全て入力された時のみ、それら全てを設定するオプションが追加されます。<br>
            4. アドレスとポート、アカウント名、パスワードが全て入力された時のみ、それら全てを設定するオプションが追加されます。
        </div>
        <div class="form-area">
            <label for="qtProxyAddress">・アドレス</label><br>
            <input type="text" class="input-text" id="qtProxyAddress" v-model="inputedQtProxy.address"
                name="qtProxyAddress" @input="updateOpt" placeholder="xxx.xxx.xxx.xxx"><br>
            <label for="qtProxyPort">・ポート番号</label><br>
            <input type="text" class="input-text" id="qtProxyPort" v-model="inputedQtProxy.port" name="qtProxyPort"
                @input="updateOpt" placeholder="8888"><br>
            <label for="qtProxyAccount">・アカウント</label><br>
            <input type="text" class="input-text" id="qtProxyAccount" v-model="inputedQtProxy.account"
                name="qtProxyAccount" @input="updateOpt" placeholder="your_account"><br>
            <label for="qtProxyPassword">・パスワード</label><br>
            <input type="text" class="input-text" id="qtProxyPassword" v-model="inputedQtProxy.password"
                name="qtProxyPassword" @input="updateOpt" placeholder="your_password"><br>
        </div>
    </fieldset>
</template>

<script>
import { onMounted, reactive, ref, watch } from 'vue';

import makeOpt from '@/js/makeOpt.js'
import cacheUtils from '@/js/cacheUtils';

export default {
    name: 'QtForm',
    props: {
        testrunNameList: {
            type: Array,
            default: () => [],
        },
        isSilent: {
            type: Boolean,
            default: true,
        },
        optDict: {
            type: Object,
            default: () => { },
        },
    },
    setup(props, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const inputedQt = reactive({
            workspace: '',
            apiKey: '',
            tdashTestrun: '',
            qtProject: '',
            usePreviousTestrun: false,
            startDate: '',
            endDate: '',
        })
        const inputedQtProxy = reactive({
            address: '',
            port: '',
            account: '',
            password: '',
        })

        // ###################################
        // QT連携テストラン名セレクトリスト制御 #
        // ###################################
        const isExistTestrunCandidate = ref(false)
        const changeCandiateState = async (testrunNameList) => {
            if (testrunNameList.length === 0) {
                isExistTestrunCandidate.value = false
            } else {
                isExistTestrunCandidate.value = testrunNameList.some(item => item !== '')

            }
        }
        const isExistInCandiate = async (testrunName) => {
            return props.testrunNameList.some(item => item === testrunName)
        }

        // ############
        // propsの監視 #
        // * propsをcomputedに入れると無限に呼び出されるため、watchで関数を発火させる
        // ############
        watch(
            () => props.testrunNameList,
            async () => {
                // 「実行するテストラン名」フォームに変更があり、
                // その中に完全一致するテストラン名が存在しない場合、
                // QT連携のテストラン名をリセット
                await changeCandiateState(props.testrunNameList)
                if (await isExistInCandiate(inputedQt.tdashTestrun)) {
                    return;
                }
                // * isNeedQtの中身の更新時は、watchできないっぽいので、手動で更新処理を呼び出す
                inputedQt.tdashTestrun = ""
                isNeedQt.value = await makeOpt.isNeedQtOpt(inputedQt)
                // 更新された状態でオプションを更新
                await updateOpt()
            }
        )

        // サイレントモード設定の監視
        watch(
            () => props.isSilent,
            async () => {
                await updateOpt()
            }
        )

        // PJインポートするかしないかを監視
        const includesUseExistingTestOpt = ref(false)
        watch(
            () => props.optDict?.sync,
            async () => {
                includesUseExistingTestOpt.value = props.optDict?.sync.includes(" --use_existing_test")
                if (!includesUseExistingTestOpt.value) {
                    inputedQt.usePreviousTestrun = false
                    await updateOpt()
                }
            }
        )

        // ##############
        // 外部連携フラグ #
        // * reactiveで宣言した場合、watchを使う
        // ##############
        const isNeedQt = ref(false)

        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            // サイレント
            let createdOpt = ""

            // QT
            isNeedQt.value = await makeOpt.isNeedQtOpt(inputedQt)
            if (isNeedQt.value && isExistTestrunCandidate.value) {
                createdOpt += await makeOpt.createQtOpt(inputedQt)
                createdOpt += await makeOpt.createProxyOpt("qt", inputedQtProxy, props.isSilent)
            }

            // cacheに保存
            await cacheUtils.saveData("qtWorkspace", inputedQt.workspace)
            await cacheUtils.saveData("qtApiKey", inputedQt.apiKey)
            await cacheUtils.saveData("qtTdashTestrun", inputedQt.tdashTestrun)
            await cacheUtils.saveData("qtQtProject", inputedQt.qtProject)
            await cacheUtils.saveData("qtUsePreviousTestrun", inputedQt.usePreviousTestrun)
            await cacheUtils.saveData("qtStartDate", inputedQt.startDate)
            await cacheUtils.saveData("qtEndDate", inputedQt.endDate)
            await cacheUtils.saveData("qtProxyAddress", inputedQtProxy.address)
            await cacheUtils.saveData("qtProxyPort", inputedQtProxy.port)
            await cacheUtils.saveData("qtProxyAccount", inputedQtProxy.account)
            await cacheUtils.saveData("qtProxyPassword", inputedQtProxy.password)

            // テストラン名候補が存在するかをチェック
            await changeCandiateState(props.testrunNameList)

            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "qt", createdOpt)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            inputedQt.workspace = await cacheUtils.getData("qtWorkspace")
            inputedQt.apiKey = await cacheUtils.getData("qtApiKey")
            inputedQt.tdashTestrun = await cacheUtils.getData("qtTdashTestrun")
            inputedQt.qtProject = await cacheUtils.getData("qtQtProject")
            inputedQt.usePreviousTestrun = await cacheUtils.getData("qtUsePreviousTestrun", false)
            inputedQt.startDate = await cacheUtils.getData("qtStartDate")
            inputedQt.endDate = await cacheUtils.getData("qtEndDate")
            inputedQtProxy.address = await cacheUtils.getData("qtProxyAddress")
            inputedQtProxy.port = await cacheUtils.getData("qtProxyPort")
            inputedQtProxy.account = await cacheUtils.getData("qtProxyAccount")
            inputedQtProxy.password = await cacheUtils.getData("qtProxyPassword")

            await updateOpt()
        })

        return {
            // フォームデータ
            inputedQt,
            inputedQtProxy,
            // コマンド生成
            updateOpt,
            // 外部連携フラグ
            isNeedQt,
            isExistTestrunCandidate,
            // コマンド監視
            includesUseExistingTestOpt,
        }
    }
}
</script>
<style scoped>
.msg-input::placeholder {
    color: red;
}

.qt-checkbox {
    margin-top: 6px;
    margin-bottom: 12px;
}
</style>